import { createActionGroup, props } from '@ngrx/store';

export const AdventActions = createActionGroup({
  source: 'advent',
  events: {
    '[advent] Set Advent': props<{
      data: boolean;
    }>(),
    '[advent] Set Advent Date': props<{
      data: number;
    }>(),
    '[advent] Set Has Claimed Advent Bonus': props<{
      data: boolean;
    }>(),
    '[advent] Set Keystone Advent': props<{
      data: any;
    }>(),
    '[advent] Set Advent Bonus': props<{ data: string }>(),
  },
});
